import React, { useState, useEffect } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate, WAITINGGIF, getwhatsappqr } from "../../util/global";


const WhatsappFormNoAuth = ({ formdata, setformdata, handlesubmit }) => {

  useEffect(() => { 
  }, []);


  const fetchqr = async (params) => {
    $("#qrcodearea").html("<div style=\"height:180px;\">Processing " + WAITINGGIF + " </div>");
    params.count++;
    let phonenumber = params.phonenumber;

    if (params.count > 20) {
      alert("Unable to connect to " + params.phonenumber + ". The phone number have country code.");
      return;
    }

    if (phonenumber.length != 12) {
      alert("Invalid phone numbr. Phone number should be 12 digits. Country code + phone number.");
      return;
    }

    const data = await getwhatsappqr(phonenumber);//{status:"connected"};

    if (data.status == "connected") {
      formdata.status = "connected";
      handlesubmit();
      return;
    }

    $("#qrcodearea").html("<div style=\"height:180px;\">Please wait for QR Code " + WAITINGGIF + " </div>");

    if (!data.qr || data.qr == "") {
      setTimeout(() => {fetchqr(params);}, 10000);
      return;
    }
    $("#qrcodearea").html("Waiting for device linking "  + WAITINGGIF + "  <br><img  src=\"" + data.qr + "\" style=\"height:150px;\">");

    setTimeout(() => {fetchqr(params);}, 10000);
  };



  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "Edit Phone Number" : "New Phone Number"}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">



          <div className="form-group" >
            <label>Name</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.name} 
              onChange={(e) => {setformdata({...formdata,name:e.target.value})}}
            />
           
          </div>

          <div className="form-group">
            <label>Phone Number (with country code)</label>
            <input 
              type="text" 
              className="form-input"
              placeHolder="Numbers Only" 
              value={formdata.phonenumber} 
              onChange={(e) => setformdata({...formdata, phonenumber: e.target.value.replace(/[^0-9]+/gi, "")})} 
            />              
          </div>
          <div className="form-group">
            <div style={{ 
              width: '220px', height: '220px', background: '#f0f2f5', margin: '0 auto', 
              borderRadius: '24px', border: '1px solid #e9edef',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <div style={{ padding: '24px', background: 'white', borderRadius: '16px', border: '1px solid #e9edef' }}>
                <span style={{ color: '#666', fontSize: '13px' }} id="qrcodearea">[QR Code Area]</span>
              </div>
            </div>
          </div>
        
          <button className="btn-blue full-width" onClick={() => {fetchqr( {count:0, phonenumber:formdata.phonenumber});}}>
            {formdata._id ? "Proceed" : "Proceed"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsappFormNoAuth;